var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.631,
    height: 17.28,
    viewBox: "0 0 15.631 17.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "promotion",
    transform: "translate(-7.146 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35460",
    "data-name": "Group 35460",
    transform: "translate(7.146 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63868",
    "data-name": "Path 63868",
    d: "M16.038,54.5,15.4,58.783V58.8h1.786l.547-3.664-1.167-.365A2.412,2.412,0,0,1,16.038,54.5Z",
    transform: "translate(-13.896 -45.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63869",
    "data-name": "Path 63869",
    d: "M8.578,24.06l.4-1.4.784-.383-.273,2.807a.9.9,0,0,0,.6.93l2.442.766.036,2.442h1.768l-.055-3.1a.859.859,0,0,0-.62-.82l-1.549-.492.437-1.932.747.948a.722.722,0,0,0,.766.255l1.677-.437a.734.734,0,1,0-.365-1.422l-1.2.31-.93-1.185c-.036-.036-.055-.073-.091-.109A1.922,1.922,0,0,0,12.3,20.8l-1.385-.292a1.894,1.894,0,0,0-1.221.146l-1.64.784a.734.734,0,0,0-.383.456l-.492,1.732a.737.737,0,0,0,.51.911.775.775,0,0,0,.2.036A.7.7,0,0,0,8.578,24.06Z",
    transform: "translate(-7.146 -17.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63870",
    "data-name": "Path 63870",
    d: "M25.646,53.5H22.492a.366.366,0,0,0-.365.365v1.367H18.81a.366.366,0,0,0-.365.365v1.367H15.128a.366.366,0,0,0-.365.365v1.367h-3.3a.366.366,0,0,0-.365.365v2.06a.366.366,0,0,0,.365.365H25.646a.366.366,0,0,0,.365-.365V53.828A.36.36,0,0,0,25.646,53.5Z",
    transform: "translate(-10.379 -44.204)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_260",
    "data-name": "Ellipse 260",
    cx: 1.549,
    cy: 1.549,
    r: 1.549,
    transform: "translate(3.491)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.072a0b2eea4e022aad2c2311353b3f51.svg";
export { ForwardRef as ReactComponent };